import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIconBlueLogo = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 19,
	height: 22,
	viewBox: "0 0 19 22",
	fill: "none",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M0.326172 2.71101C0.326172 1.27054 1.49393 0.102783 2.9344 0.102783C4.3748 0.102783 5.54256 1.27054 5.54256 2.71101V21.4505C5.54256 21.5038 5.49931 21.5471 5.44597 21.5471H2.93433C1.49393 21.5471 0.326172 20.3794 0.326172 18.9389V2.71101Z",
		fill: "#0587FB"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M13.6093 21.5471C16.5703 21.5471 18.9706 19.1469 18.9706 16.186C18.9706 13.2252 16.5703 10.825 13.6093 10.825C10.6484 10.825 8.24805 13.2252 8.24805 16.186C8.24805 19.1469 10.6484 21.5471 13.6093 21.5471Z",
		fill: "#0587FB"
	})]
});
export default SvgIconBlueLogo;
